import { render, staticRenderFns } from "./NeedsActionClaim.vue?vue&type=template&id=ac3e781e&scoped=true"
import script from "./NeedsActionClaim.vue?vue&type=script&lang=js"
export * from "./NeedsActionClaim.vue?vue&type=script&lang=js"
import style0 from "./NeedsActionClaim.vue?vue&type=style&index=0&id=ac3e781e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac3e781e",
  null
  
)

export default component.exports